import { Outlet, useSearchParams } from 'react-router-dom';
import CandidateInfoTopbar from './CandidateInfoTopbar';
import { useEffect, useState } from 'react';
import { DivisionChartItemType } from '@type/dashboard';
import { SelectElectionModal } from '@components/SelectElectionModal';
import { useElections } from '@hooks/useElections';

function CandidateInfoLayoutView() {
  let [searchParams] = useSearchParams();
  const [electionScheduleName, setElectionScheduleName] = useState<string>('');

  const [isElectionSelectModalOpen, setIsElectionSelectModalOpen] =
    useState<boolean>(searchParams.get('election_schedule_id') ? false : true);

  const [divisionChartState, setDivisionChartState] = useState<
    DivisionChartItemType[]
  >([]);

  const electionsData = useElections();

  const openElectionModalHandler = () => {
    setIsElectionSelectModalOpen(true);
  };

  const closeElectionModalHandler = () => {
    setIsElectionSelectModalOpen(false);
  };

  useEffect(() => {
    if (electionsData.elections) {
      const query_election_settings_id =
        searchParams.get('election_schedule_id') || '';

      const selectedElection = electionsData.elections.find(
        (item) =>
          `${item.election_schedule_id || ''}` === query_election_settings_id,
      );

      setElectionScheduleName(
        selectedElection?.election_name_bn
          ? selectedElection.election_name_bn
          : '',
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [electionsData.elections]);

  return (
    <div className="container">
      <div className="row g-0">
        <div className="col-12 col-md-12 col-lg-12 col-xl-12 px-10 px-sm-20 pt-0">
          <CandidateInfoTopbar
            electionScheduleName={electionScheduleName}
            openElectionModalHandler={openElectionModalHandler}
          />
          {searchParams.get('election_schedule_id') && (
            <Outlet context={{ divisionChartState, setDivisionChartState }} />
          )}
        </div>
      </div>

      {isElectionSelectModalOpen && (
        <SelectElectionModal
          electionsData={electionsData}
          isOpen={isElectionSelectModalOpen}
          onClose={closeElectionModalHandler}
          setDivisionChartState={setDivisionChartState}
          setElectionScheduleName={setElectionScheduleName}
        />
      )}
    </div>
  );
}

export default CandidateInfoLayoutView;
